export default __webpack_public_path__ + "static/media/location_icon.d82bee2d.svg";